import { createSelector } from '@reduxjs/toolkit';
import { selectSitePricingCheckoutDelegateMetaById } from '../../../checkoutDetails';

export const selectDelegateCountryOptions = createSelector(
  [selectSitePricingCheckoutDelegateMetaById],
  (meta) => meta?.countries || [],
);
